<template>
  <div class="contract-create-container">
    <!-- 左侧蓝色标记和标题 -->
    <div class="page-header">
      <div class="blue-bar"></div>
      <h2 class="page-title">{{ pageTitle }}</h2>
    </div>
    
    <!-- 步骤条 -->
    <div class="steps-container">
      <el-steps :active="activeStep" finish-status="success" align-center>
        <el-step title="基本信息" description="合同名称、单位信息和关联项目"></el-step>
        <el-step title="合同详情" description="计价方式、计息等"></el-step>
        <el-step title="导入清单" description="导入合同清单"></el-step>
      </el-steps>
    </div>
    
    <!-- 步骤内容 -->
    <div class="step-content">
      <!-- 第一步：基本信息 -->
      <div v-show="activeStep === 0" class="step-panel">
        <h3 class="step-title">第一步：基本信息</h3>
        <el-form :model="step1Form" :rules="step1Rules" ref="step1Form" label-position="top">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="合同名称" prop="contractName">
                <el-input 
                  v-model="step1Form.contractName" 
                  placeholder="请输入合同名称"
                  :disabled="isView"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="需求方单位" prop="customerUnitIds">
                <el-select 
                  v-model="step1Form.customerUnitIds" 
                  placeholder="请选择需求方单位" 
                  multiple 
                  filterable
                  :disabled="isView"
                  @change="handleCustomerUnitChange"
                >
                  <el-option
                    v-for="unit in customerOptions"
                    :key="unit.id"
                    :label="unit.unit_name || unit.unitName"
                    :value="unit.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="供方单位" prop="supplierUnitId">
                <el-select 
                  v-model="step1Form.supplierUnitId" 
                  placeholder="请选择供方单位" 
                  filterable
                  :disabled="isView"
                >
                  <el-option
                    v-for="unit in supplierOptions"
                    :key="unit.id"
                    :label="unit.unit_name || unit.unitName"
                    :value="unit.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="关联项目（可选）" prop="projectIds">
                <el-select 
                  v-model="step1Form.projectIds" 
                  placeholder="请选择关联项目（可选）" 
                  multiple 
                  filterable
                  :disabled="isView"
                  clearable
                >
                  <el-option
                    v-for="project in projectOptions"
                    :key="project.id"
                    :label="project.projectName"
                    :value="project.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="合同联系人" prop="contactPerson">
                <el-autocomplete
                  v-model="step1Form.contactPerson"
                  :fetch-suggestions="queryContactUsers"
                  placeholder="请输入合同联系人"
                  :trigger-on-focus="false"
                  value-key="username"
                  @select="handleContactPersonSelect"
                  :disabled="isView"
                  style="width: 100%"
                >
                  <template slot-scope="{ item }">
                    <div class="user-option">
                      <span class="user-name">{{ item.username }}</span>
                      <span class="user-phone">{{ item.phone || '-' }}</span>
                    </div>
                  </template>
                </el-autocomplete>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系电话" prop="contactPhone">
                <el-input 
                  v-model="step1Form.contactPhone" 
                  placeholder="请输入联系电话"
                  :disabled="isView"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      
      <!-- 第二步：合同详情 -->
      <div v-show="activeStep === 1" class="step-panel">
        <h3 class="step-title">第二步：合同详情</h3>
        <el-form :model="step3Form" :rules="step3Rules" ref="step3Form" label-position="top">
                     <el-row :gutter="20">
             <el-col :span="8">
               <el-form-item label="计价方式" prop="pricingMethod">
                 <el-select v-model="step3Form.pricingMethod" placeholder="请选择计价方式">
                   <el-option label="固定价" value="FIXED"></el-option>
                   <el-option label="变动价" value="FLOATING"></el-option>
                 </el-select>
               </el-form-item>
             </el-col>
             <el-col :span="8">
               <el-form-item label="是否计息" prop="interestCalculation">
                 <el-radio-group v-model="step3Form.interestCalculation">
                   <el-radio :label="true">是</el-radio>
                   <el-radio :label="false">否</el-radio>
                 </el-radio-group>
               </el-form-item>
             </el-col>
           </el-row>
          
                     <el-row :gutter="20">
             <el-col :span="8">
               <el-form-item label="支付方式" prop="settlementMethod">
                 <el-select 
                   ref="paymentSelect"
                   v-model="selectedPaymentMethods" 
                   placeholder="请选择支付方式"
                   multiple
                   @change="handlePaymentMethodChange"
                   @visible-change="debugPaymentMethodsStatus"
                 >
                   <el-option label="转账支付" value="转账支付"></el-option>
                   <el-option label="银行票据" value="银行票据"></el-option>
                   <el-option label="金融产品" value="金融产品"></el-option>
                   <el-option label="其他形式" value="其他形式"></el-option>
                 </el-select>
               </el-form-item>
             </el-col>
                           <el-col :span="8">
                <el-form-item label="结算周期" prop="settlementCycle">
                  <el-select 
                    v-model="step3Form.settlementCycle" 
                    placeholder="请选择结算周期"
                    style="width: 100%;"
                  >
                    <el-option label="上月21日-本月20日" value="MONTHLY_21_TO_20"></el-option>
                    <el-option label="上月26日-本月25日" value="MONTHLY_26_TO_25"></el-option>
                    <el-option label="货到当天" value="TO_MONTH_END"></el-option>
                    <el-option label="发货当天" value="TO_SHIPPING_DAY"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
           </el-row>
           
                       <!-- 付款天数设置 -->
            <el-form-item label="付款天数">
              <div class="payment-days-container">
                <div 
                  v-for="(payment, index) in paymentDays" 
                  :key="index"
                  class="payment-item"
                >
                  <el-input 
                    v-model="payment.days" 
                    placeholder="天数"
                    class="payment-days"
                    style="width: 100px;"
                  ></el-input>
                  <span class="unit-text">天后付款</span>
                  <el-input 
                    v-model="payment.percentage" 
                    placeholder="百分比"
                    class="payment-percentage"
                    style="width: 100px;"
                  ></el-input>
                  <span class="unit-text">%</span>
                  <el-button 
                    type="danger" 
                    size="mini" 
                    icon="el-icon-delete"
                    @click="removePaymentDay(index)"
                  >删除</el-button>
                </div>
                <el-button 
                  type="primary" 
                  size="mini" 
                  icon="el-icon-plus"
                  @click="addPaymentDay"
                >新增付款天数</el-button>
              </div>
            </el-form-item>

            <el-form-item label="免息天数" prop="interestFreeDays">
              <div style="display: flex; align-items: center;">
                <el-input-number
                  v-model="step3Form.interestFreeDays"
                  :min="0"
                  :max="99999"
                  :precision="0"
                  :step="1"
                  controls-position="right"
                  placeholder="免息天数"
                  style="width: 160px;"
                ></el-input-number>
                <span class="unit-text" style="margin-left: 8px;">天</span>
              </div>
            </el-form-item>
          
                     <el-row :gutter="20">
             <el-col :span="8">
               <el-form-item label="利率类型" prop="interestRateType">
                 <el-radio-group v-model="step3Form.interestRateType" @change="handleInterestTypeChange">
                   <el-radio label="FIXED">固定利率</el-radio>
                   <el-radio label="VARIABLE">变动利率</el-radio>
                 </el-radio-group>
               </el-form-item>
             </el-col>
                           <el-col :span="8" v-if="step3Form.interestRateType === 'FIXED'">
                <el-form-item label="固定利率" prop="fixedInterestRate">
                  <div style="display: flex; align-items: center;">
                    <el-input-number 
                      v-model="step3Form.fixedInterestRate" 
                      :min="0" 
                      :max="100"
                      :precision="2"
                      placeholder="利率"
                      style="flex: 1;"
                    ></el-input-number>
                    <span class="unit-text" style="margin-left: 8px;">%</span>
                  </div>
                </el-form-item>
              </el-col>
           </el-row>
          
                     <!-- 变动利率设置 -->
           <div v-if="step3Form.interestRateType === 'VARIABLE'">
             <el-form-item label="变动利率">
               <div class="variable-rates-container">
                 <div 
                   v-for="(rate, index) in variableRates" 
                   :key="index"
                   class="rate-item"
                 >
                   <!-- 最后一条显示为"XX天以上" -->
                   <template v-if="index === variableRates.length - 1">
                     <el-input 
                       v-model="rate.startDays" 
                       placeholder="天数"
                       class="rate-days"
                       style="width: 120px;"
                     ></el-input>
                     <span class="unit-text">天以上，利率</span>
                     <el-input 
                       v-model="rate.rate" 
                       placeholder="利率"
                       class="rate-value"
                       style="width: 80px;"
                     ></el-input>
                     <span class="unit-text">%</span>
                   </template>
                   <!-- 非最后一条显示为"XX天到XX天" -->
                   <template v-else>
                     <el-input 
                       v-model="rate.startDays" 
                       placeholder="开始天数"
                       class="rate-days"
                       style="width: 120px;"
                     ></el-input>
                     <span class="unit-text">天到</span>
                     <el-input 
                       v-model="rate.endDays" 
                       placeholder="结束天数"
                       class="rate-days"
                       style="width: 120px;"
                     ></el-input>
                     <span class="unit-text">天，利率</span>
                     <el-input 
                       v-model="rate.rate" 
                       placeholder="利率"
                       class="rate-value"
                       style="width: 80px;"
                     ></el-input>
                     <span class="unit-text">%</span>
                   </template>
                   <el-button 
                     type="danger" 
                     size="mini" 
                     icon="el-icon-delete"
                     @click="removeVariableRate(index)"
                   >删除</el-button>
                 </div>
                 <el-button 
                   type="primary" 
                   size="mini" 
                   icon="el-icon-plus"
                   @click="addVariableRate"
                 >新增变动利率</el-button>
               </div>
             </el-form-item>
           </div>
        </el-form>
      </div>
      
      <!-- 第三步：导入清单 -->
      <div v-show="activeStep === 2" class="step-panel">
        <h3 class="step-title">第三步：导入清单</h3>
        <div class="import-section">
          <!-- 计价方式提示 -->
          <div class="pricing-method-tip">
            <el-alert
              :title="`当前计价方式：${step3Form.pricingMethod === 'FIXED' ? '固定价' : '变动价'}`"
              :description="getPricingMethodDescription()"
              :type="step3Form.pricingMethod === 'FIXED' ? 'success' : 'warning'"
              :closable="false"
              show-icon
            ></el-alert>
          </div>
          
          <!-- 模板下载 -->
          <div class="template-download">
            <el-button 
              v-permission="'contracts:contract-create:download-template'"
              type="info" 
              icon="el-icon-download" 
              @click="downloadTemplate"
              :disabled="!step3Form.pricingMethod"
            >
              下载{{ step3Form.pricingMethod === 'FIXED' ? '固定价' : '变动价' }}清单模板
            </el-button>
            <span class="template-tip">请先下载对应模板，按模板格式填写后导入</span>
          </div>
          
          <!-- 文件上传 -->
          <el-upload
            class="excel-uploader"
            action="#"
            :show-file-list="false"
            :before-upload="beforeExcelUpload"
            :http-request="handleExcelUpload"
          >
            <el-button v-permission="'contracts:contract-create:import'" type="primary" icon="el-icon-upload2">导入Excel清单</el-button>
          </el-upload>
          
          <div class="upload-tip">
            <p>支持格式：.xlsx, .xls</p>
            <p>文件大小：不超过10MB</p>
            <p>{{ getUploadTipText() }}</p>
          </div>
        </div>
        
        <!-- 没有清单时的新增按钮 -->
        <div v-if="contractItems.length === 0" class="empty-items-section">
          <el-button 
            type="primary" 
            icon="el-icon-plus" 
            @click="openItemDialog()"
            :disabled="isView"
          >新增清单项</el-button>
          <p class="empty-tip">您可以手动新增清单项，或使用上方的Excel导入功能</p>
        </div>
        
        <!-- 清单预览 -->
        <div v-if="contractItems.length > 0" class="items-preview">
          <div class="preview-header">
            <h4>清单预览</h4>
            <el-button 
              type="primary" 
              size="small" 
              icon="el-icon-plus" 
              @click="openItemDialog()"
              :disabled="isView"
            >新增清单项</el-button>
          </div>
          
          <!-- 固定价表格 -->
          <el-table 
            v-if="step3Form.pricingMethod === 'FIXED'" 
            :data="contractItems" 
            border 
            style="width: 100%"
          >
            <el-table-column label="序号" prop="sequenceNumber" width="60" align="center"></el-table-column>
            <el-table-column label="材料名称" prop="productName" min-width="150" align="center"></el-table-column>
            <el-table-column label="规格型号" prop="specification" min-width="150" align="center">
              <template slot-scope="scope">
                <el-tooltip
                  v-if="scope.row.specification"
                  :content="scope.row.specification"
                  placement="top"
                  effect="dark"
                  popper-class="spec-tooltip"
                >
                  <span>{{ truncateText(scope.row.specification, 20) }}</span>
                </el-tooltip>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="材质要求" prop="materialRequirement" min-width="100" align="center"></el-table-column>
            <el-table-column label="单位" prop="unit" width="80" align="center"></el-table-column>
            <el-table-column label="暂定数量" prop="quantity" width="120" align="center"></el-table-column>
                         <el-table-column label="不含税单价(元)" prop="taxExclusiveUnitPrice" width="120" align="center">
               <template slot-scope="scope">
                 {{ formatUnitPrice(scope.row.taxExclusiveUnitPrice) }}
               </template>
             </el-table-column>
             <el-table-column label="含税单价(元)" prop="taxInclusiveUnitPrice" width="120" align="center">
               <template slot-scope="scope">
                 {{ formatUnitPrice(scope.row.taxInclusiveUnitPrice) }}
               </template>
             </el-table-column>
             <el-table-column label="含税合价(元)" prop="taxInclusiveTotalAmount" width="120" align="center">
               <template slot-scope="scope">
                 {{ formatAmount(scope.row.taxInclusiveTotalAmount) }}
               </template>
             </el-table-column>
            <el-table-column label="税率" prop="taxRate" width="80" align="center">
              <template slot-scope="scope">
                {{ formatPercentage(scope.row.taxRate) }}
              </template>
            </el-table-column>
            <el-table-column label="备注" prop="remark" width="150" align="center"></el-table-column>
            <el-table-column label="操作" fixed="right" width="120" align="center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="openItemDialog(scope.row, scope.$index)"
                  :disabled="isView"
                >编辑</el-button>
                <el-button
                  v-permission="'contracts:contract-create:delete-item'"
                  type="text"
                  size="small"
                  @click="removeItem(scope.$index)"
                  :disabled="isView"
                  style="color: #f56c6c;"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          
          <!-- 变动价表格 -->
          <el-table 
            v-if="step3Form.pricingMethod === 'FLOATING'" 
            :data="contractItems" 
            border 
            style="width: 100%"
          >
            <el-table-column label="序号" prop="sequenceNumber" width="60" align="center"></el-table-column>
            <el-table-column label="材料名称" prop="productName" min-width="150" align="center"></el-table-column>
            <el-table-column label="规格型号" prop="specification" min-width="150" align="center">
              <template slot-scope="scope">
                <el-tooltip
                  v-if="scope.row.specification"
                  :content="scope.row.specification"
                  placement="top"
                  effect="dark"
                  popper-class="spec-tooltip"
                >
                  <span>{{ truncateText(scope.row.specification, 20) }}</span>
                </el-tooltip>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="材质要求" prop="materialRequirement" min-width="150" align="center"></el-table-column>
            <el-table-column label="单位" prop="unit" width="80" align="center"></el-table-column>
            <el-table-column label="暂定数量" prop="quantity" width="120" align="center"></el-table-column>
                         <el-table-column label="含税固定价(元)" prop="taxInclusiveBasePrice" width="120" align="center">
               <template slot-scope="scope">
                 {{ formatAmount(scope.row.taxInclusiveBasePrice) }}
               </template>
             </el-table-column>
             <el-table-column label="含税变动价(元)" prop="taxInclusiveFloatingPrice" width="120" align="center">
               <template slot-scope="scope">
                 {{ formatAmount(scope.row.taxInclusiveFloatingPrice) }}
               </template>
             </el-table-column>
             <el-table-column label="含税合价(元)" prop="taxInclusiveTotalAmount" width="120" align="center">
               <template slot-scope="scope">
                 {{ formatAmount(scope.row.taxInclusiveTotalAmount) }}
               </template>
             </el-table-column>
            <el-table-column label="税率" prop="taxRate" width="80" align="center">
              <template slot-scope="scope">
                {{ formatPercentage(scope.row.taxRate) }}
              </template>
            </el-table-column>
            <el-table-column label="备注" prop="remark" width="150" align="center"></el-table-column>
            <el-table-column label="操作" width="120" align="center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="openItemDialog(scope.row, scope.$index)"
                  :disabled="isView"
                >编辑</el-button>
                <el-button
                  v-permission="'contracts:contract-create:delete-item'"
                  type="text"
                  size="small"
                  @click="removeItem(scope.$index)"
                  :disabled="isView"
                  style="color: #f56c6c;"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    
    <!-- 步骤操作按钮 -->
    <div class="step-actions">
      <!-- 查看模式下的提示 -->
      <div v-if="isView" class="view-mode-tip">
        <el-alert
          title="查看模式"
          description="您可以浏览所有步骤查看合同信息，所有字段均为只读状态"
          type="info"
          :closable="false"
          show-icon
        ></el-alert>
      </div>
      
      <el-button v-if="activeStep > 0" @click="prevStep">上一步</el-button>
      <el-button 
        v-if="activeStep < 2" 
        type="primary" 
        @click="nextStep"
      >下一步</el-button>
      <el-button
        v-if="!isView"
        type="info"
        icon="el-icon-paperclip"
        @click="attachmentDialogVisible = true"
      >附件<span v-if="attachmentCount">（{{ attachmentCount }}）</span></el-button>
      <el-button 
        v-if="activeStep === 2 && !isView" 
        v-permission="'contracts:contract-create:create'"
        type="success" 
        @click="saveContract"
        :loading="saving"
        :disabled="attachmentUploading"
      >{{ isEdit ? '更新合同' : '保存合同' }}</el-button>
      <el-button @click="goBack">返回</el-button>
    </div>

      <el-dialog
        title="选择合同复核人"
        :visible.sync="reviewDialogVisible"
        width="420px"
        append-to-body
      >
        <el-select v-model="reviewerId" placeholder="请选择同单位复核人" style="width:100%">
          <el-option v-for="user in reviewerOptions" :key="user.id" :label="user.realName || user.username" :value="user.id" />
        </el-select>
        <span slot="footer">
          <el-button @click="reviewDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmReviewSave">提交复核</el-button>
        </span>
      </el-dialog>
      <el-dialog
      v-dialog-drag
      title="合同附件"
      :visible.sync="attachmentDialogVisible"
      width="760px"
      :close-on-click-modal="false"
    >
      <contract-attachments
        :contract-id="contractId"
        :upload-token="uploadToken"
        @count-change="handleAttachmentCountChange"
        @uploading-change="attachmentUploading = $event"
      />
      <div slot="footer" class="dialog-footer">
        <el-button @click="attachmentDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 编辑/新增清单项弹出对话框 -->
    <el-dialog
      v-dialog-drag
      :title="itemDialogTitle"
      :visible.sync="itemDialogVisible"
      width="800px"
      :close-on-click-modal="false"
      @close="closeItemDialog"
    >
      <el-form
        ref="itemForm"
        :model="itemForm"
        :rules="itemFormRules"
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="序号" prop="sequenceNumber">
              <el-input-number
                v-model="itemForm.sequenceNumber"
                :min="1"
                :max="9999"
                placeholder="序号"
                style="width: 100%;"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="材料名称" prop="productName">
              <el-input
                v-model="itemForm.productName"
                placeholder="请输入材料名称"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="规格型号（可选）" prop="specification">
              <el-input
                v-model="itemForm.specification"
                placeholder="请输入规格型号（可选）"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="材质要求" prop="materialRequirement">
              <el-input
                v-model="itemForm.materialRequirement"
                placeholder="请输入材质要求"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="单位" prop="unit">
              <el-input
                v-model="itemForm.unit"
                placeholder="请输入单位"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="暂定数量" prop="quantity">
              <el-input-number
                v-model="itemForm.quantity"
                :min="0"
                :max="999999"
                :precision="4"
                :step="0.0001"
                placeholder="数量"
                style="width: 100%;"
                @change="calculateTotalAmount"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="税率" prop="taxRate">
              <el-input-number
                v-model="itemForm.taxRate"
                :min="0"
                :max="100"
                :precision="2"
                placeholder="税率（可输入13或0.13）"
                style="width: 100%;"
                @change="handleTaxRateChange"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 固定价格字段 -->
        <div v-if="step3Form.pricingMethod === 'FIXED'">
          <el-row :gutter="20">
            <el-col :span="8">
                <el-form-item label="不含税单价(元)" prop="taxExclusiveUnitPrice">
                <el-input-number
                  v-model="itemForm.taxExclusiveUnitPrice"
                  :precision="8"
                  placeholder="不含税单价"
                  style="width: 100%;"
                  @change="calculateFromExclusivePrice"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="含税单价(元)" prop="taxInclusiveUnitPrice">
                <el-input-number
                  v-model="itemForm.taxInclusiveUnitPrice"
                  :precision="8"
                  placeholder="含税单价"
                  style="width: 100%;"
                  @change="calculateFromInclusivePrice"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="含税合价(元)" prop="taxInclusiveTotalAmount">
                <el-input-number
                  v-model="itemForm.taxInclusiveTotalAmount"
                  :min="0"
                  :precision="2"
                  placeholder="含税合价"
                  style="width: 100%;"
                  :disabled="true"
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 变动价格字段 -->
        <div v-if="step3Form.pricingMethod === 'FLOATING'">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="含税固定价(元)" prop="taxInclusiveBasePrice">
                <el-input-number
                  v-model="itemForm.taxInclusiveBasePrice"
                  :min="0"
                  :precision="2"
                  placeholder="含税固定价"
                  style="width: 100%;"
                  @change="calculateTotalAmount"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="含税变动价(元)" prop="taxInclusiveFloatingPrice">
                <el-input-number
                  v-model="itemForm.taxInclusiveFloatingPrice"
                  :min="0"
                  :precision="2"
                  placeholder="含税变动价"
                  style="width: 100%;"
                  @change="calculateTotalAmount"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="含税合价(元)" prop="taxInclusiveTotalAmount">
                <el-input-number
                  v-model="itemForm.taxInclusiveTotalAmount"
                  :min="0"
                  :precision="2"
                  placeholder="含税合价"
                  style="width: 100%;"
                  :disabled="true"
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input
                v-model="itemForm.remark"
                type="textarea"
                :rows="3"
                placeholder="请输入备注"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeItemDialog">取消</el-button>
        <el-button type="primary" @click="saveItem">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import { getUserInfo } from '@/utils/auth.js';
import { saveContract, getContractById, getContractReviewers, check_contract_item_deletion } from '@/api/modules/contracts.js';
import { bindTemporaryContractAttachments } from '@/api/modules/business-document.js';
import { getAllSuppliersByUnitId, getAllCustomersByUnitId } from '@/api/modules/unit.js';
import { getProjectsByUnit } from '@/api/modules/projects.js';
import { query_users_pagination } from '@/api/modules/user.js';
import ContractAttachments from '@/components/ContractAttachments';

function createUploadToken() {
  if (window.crypto && typeof window.crypto.randomUUID === 'function') {
    return window.crypto.randomUUID();
  }
  const template = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
  return template.replace(/[xy]/g, character => {
    const randomValue = Math.floor(Math.random() * 16);
    const value = character === 'x' ? randomValue : (randomValue & 0x3) | 0x8;
    return value.toString(16);
  });
}

export default {
  name: 'ContractCreate',
  components: {
    ContractAttachments
  },
  data() {
    return {
      activeStep: 0,
      saving: false,
      isEdit: false, // 是否为编辑模式
      isView: false, // 是否为查看模式
      contractId: null, // 合同ID（编辑/查看时使用）
      pageTitle: '新增合同', // 页面标题
      uploadToken: createUploadToken(),
      attachmentDialogVisible: false,
      attachmentCount: 0,
      temporaryAttachmentCount: 0,
      attachmentUploading: false,
      reviewDialogVisible: false,
      reviewerId: null,
      reviewerOptions: [],
      pendingContractData: null,
      originalContractItems: [],
      originalContractStatus: null,
      
      // 第一步表单
      step1Form: {
        contractName: '',
        supplierUnitId: '',
        customerUnitIds: [],
        projectIds: [], // 新增关联项目ID数组
        contractUnitId: null, // 新增合同单位ID
        contactPerson: '', // 合同联系人
        contactPhone: '' // 联系电话
      },
      step1Rules: {
        contractName: [
          { required: true, message: '请输入合同名称', trigger: 'blur' }
        ],
        supplierUnitId: [
          { required: true, message: '请选择供方单位', trigger: 'change' }
        ],
        customerUnitIds: [
          { required: true, message: '请选择需求方单位', trigger: 'change' }
        ],
        projectIds: [
          // 关联项目改为可选，移除必填验证
        ],
        contactPerson: [
          // 合同联系人为可选字段
        ],
        contactPhone: [
          // 联系电话为可选字段，如果填写了则验证手机号格式
          {
            validator: (rule, value, callback) => {
              if (!value || value.trim() === '') {
                // 可选字段，为空时不验证
                callback()
              } else {
                // 验证手机号格式：11位数字，以1开头，第二位是3-9
                const phoneRegex = /^1[3-9]\d{9}$/
                if (phoneRegex.test(value.trim())) {
                  callback()
                } else {
                  callback(new Error('请输入正确的手机号码格式（11位数字，以1开头）'))
                }
              }
            },
            trigger: 'blur'
          }
        ]
      },
      
      // 第二步表单（原来的第三步）
      step3Form: {
        pricingMethod: 'FIXED',
        interestCalculation: true,
        settlementMethod: '转账支付',
        interestFreeDays: 30,
        settlementCycle: 'MONTHLY_21_TO_20', // 结算周期，默认上月21日-本月20日
        interestRateType: 'FIXED',
        fixedInterestRate: 0
      },
      
      // 支付方式多选
      selectedPaymentMethods: ['转账支付'],
      step3Rules: {
        pricingMethod: [
          { required: true, message: '请选择计价方式', trigger: 'change' }
        ],
        settlementMethod: [
          { required: true, message: '请选择支付方式', trigger: 'change' }
        ],
        settlementCycle: [
          { required: true, message: '请选择结算周期', trigger: 'change' }
        ],
        interestFreeDays: [
          { required: true, message: '请输入免息天数', trigger: 'change' },
          { type: 'number', min: 0, message: '免息天数不能小于 0', trigger: 'change' }
        ]
      },
      
      // 变动利率
      variableRates: [],
      
      // 付款天数
      paymentDays: [],
      
      // 合同清单
      contractItems: [],
      
      // 选项数据
      supplierOptions: [],
      customerOptions: [],
      projectOptions: [],
      
      // 清单项编辑对话框
      itemDialogVisible: false,
      itemDialogTitle: '新增清单项',
      editingItemIndex: -1, // -1表示新增，>=0表示编辑
      itemForm: {
        sequenceNumber: 1,
        productName: '',
        specification: '',
        materialRequirement: '',
        unit: '',
        quantity: 0,
        taxExclusiveUnitPrice: 0,
        taxInclusiveUnitPrice: 0,
        taxInclusiveBasePrice: 0,
        taxInclusiveFloatingPrice: 0,
        taxInclusiveTotalAmount: 0,
        taxRate: 13,
        remark: ''
      },
      itemFormRules: {
        sequenceNumber: [
          { required: true, message: '请输入序号', trigger: 'blur' }
        ],
        productName: [
          { required: true, message: '请输入材料名称', trigger: 'blur' }
        ],
        unit: [
          { required: true, message: '请输入单位', trigger: 'blur' }
        ],
        quantity: [
          { required: true, message: '请输入数量', trigger: 'blur' },
          { 
            validator: (rule, value, callback) => {
              if (value === null || value === undefined || value === '') {
                callback(new Error('请输入数量'));
                return;
              }
              const num = parseFloat(value);
              if (isNaN(num)) {
                callback(new Error('数量必须是数字'));
                return;
              }
              if (num < 0) {
                callback(new Error('数量不能小于0'));
                return;
              }
              // 检查小数位数（最多4位）
              const decimalPart = value.toString().split('.')[1];
              if (decimalPart && decimalPart.length > 4) {
                callback(new Error('数量最多支持4位小数'));
                return;
              }
              callback();
            },
            trigger: 'blur'
          }
        ],
        taxRate: [
          { required: true, message: '请输入税率', trigger: 'blur' },
          { type: 'number', min: 0, max: 100, message: '税率必须在0-100之间', trigger: 'blur' },
          { 
            validator: (rule, value, callback) => {
              if (value === null || value === undefined || value === '') {
                callback();
                return;
              }
              const normalizedRate = this.normalizeTaxRate(value);
              if (normalizedRate === 0) {
                callback(new Error('税率不能为0'));
              } else {
                callback();
              }
            }, 
            trigger: 'blur' 
          }
        ]
      }
    }
  },
  created() {
    this.initMode();
    this.initData();
    this.addVariableRate(); // 默认添加一个变动利率
    this.addPaymentDay(); // 默认添加一个付款天数
    
    // 只在新增模式下初始化支付方式
    if (!this.contractId) {
      this.handlePaymentMethodChange();
    }
  },
  methods: {
    handleAttachmentCountChange(counts) {
      this.attachmentCount = counts.total || 0;
      this.temporaryAttachmentCount = counts.temporary || 0;
    },

    // 初始化模式（新增/编辑/查看）
    initMode() {
      const route = this.$route;
      this.contractId = route.params.id;
      if (this.contractId) {
        this.uploadToken = '';
      }
      
      if (route.name === 'ContractEdit') {
        this.isEdit = true;
        this.pageTitle = '编辑合同';
      } else if (route.name === 'ContractView') {
        this.isView = true;
        this.pageTitle = '查看合同';
      } else {
        this.pageTitle = '新增合同';
      }
      
      // 如果是编辑或查看模式，获取合同详情
      if (this.contractId) {
        this.fetchContractDetail();
      }
    },
    
    // 获取合同详情
    async fetchContractDetail() {
      try {
        const response = await getContractById(this.contractId);
        if (response.data && response.data.success) {
          const contract = response.data.data;
          this.populateFormData(contract);
        } else {
          this.$message.error('获取合同详情失败');
        }
      } catch (error) {
        console.error('获取合同详情失败:', error);
        this.$message.error('获取合同详情失败');
      }
    },
    
    // 回显合同数据到表单
    populateFormData(contract) {
      this.originalContractStatus = contract.status || null;
      this.reviewerId = contract.status === 'DRAFT' ? (contract.reviewerId || null) : null;
      // 第一步：基本信息
      this.step1Form.contractName = contract.contractName || '';
      this.step1Form.contractUnitId = contract.contractUnitId || contract.contractUnit?.id || '';
      this.step1Form.supplierUnitId = contract.supplierUnitId || contract.supplierUnit?.id || '';
      
      // 处理需求方单位
      if (contract.demandUnits && contract.demandUnits.length > 0) {
        this.step1Form.customerUnitIds = contract.demandUnits.map(unit => unit.id);
      } else if (contract.demandUnitIds && contract.demandUnitIds.length > 0) {
        this.step1Form.customerUnitIds = contract.demandUnitIds;
      } else {
        // 从合同参与方中提取需求方单位ID
        const customerParties = contract.contractParties?.filter(party => party.partyType === 'CUSTOMER') || [];
        this.step1Form.customerUnitIds = customerParties.map(party => party.unitInfoId);
      }

      // 第二步：关联项目
      if (contract.projects && contract.projects.length > 0) {
        this.step1Form.projectIds = contract.projects.map(project => project.id);
      } else if (contract.projectIds && contract.projectIds.length > 0) {
        this.step1Form.projectIds = contract.projectIds;
      }
      
      // 合同联系人和联系电话
      this.step1Form.contactPerson = contract.contactPerson || '';
      this.step1Form.contactPhone = contract.contactPhone || '';
      
      // 如果有需求方单位，获取对应的项目列表
      if (this.step1Form.customerUnitIds && this.step1Form.customerUnitIds.length > 0) {
        this.fetchProjects();
      }
      
      // 第二步：合同详情
             this.step3Form.pricingMethod = contract.pricingMethod || 'FIXED';
       this.step3Form.interestCalculation = contract.interestCalculation !== undefined ? contract.interestCalculation : true;
       this.step3Form.interestRateType = contract.interestRateType || 'FIXED';
       this.step3Form.fixedInterestRate = contract.fixedInterestRate || 0;
       this.step3Form.settlementCycle = contract.settlementCycle || 'MONTHLY_21_TO_20';

       // 优先使用合同中的免息天数；无有效值时再按利率类型给默认
       if (contract.interestFreeDays !== undefined && contract.interestFreeDays !== null && contract.interestFreeDays !== '') {
         const parsed = Number(contract.interestFreeDays);
         if (Number.isFinite(parsed) && parsed >= 0) {
           this.step3Form.interestFreeDays = parsed;
         } else if (this.step3Form.interestRateType === 'VARIABLE') {
           this.step3Form.interestFreeDays = 0;
         } else {
           this.step3Form.interestFreeDays = 30;
         }
       } else if (this.step3Form.interestRateType === 'VARIABLE') {
         this.step3Form.interestFreeDays = 0;
       } else {
         this.step3Form.interestFreeDays = 30;
       }
       
       // 处理支付方式（从逗号分隔的字符串转换为数组）
       if (contract.settlementMethod) {
         // 分割字符串并去除首尾空格
         const paymentMethods = contract.settlementMethod.split(',')
           .map(method => method.trim())
           .filter(method => method.length > 0);
         
// 验证每个选项是否在可选列表中
         const validOptions = ['转账支付', '银行票据', '金融产品', '其他形式'];
         const filteredMethods = paymentMethods.filter(method => {
           const isValid = validOptions.includes(method);
           if (!isValid) {
             console.warn('无效的支付方式选项:', method, '字符编码:', Array.from(method).map(char => char.charCodeAt(0)));
           }
           return isValid;
         });
         
// 使用Vue.set确保响应式更新
         this.$set(this, 'selectedPaymentMethods', filteredMethods);
         this.step3Form.settlementMethod = contract.settlementMethod;
       } else {
         this.$set(this, 'selectedPaymentMethods', ['转账支付']);
         this.step3Form.settlementMethod = '转账支付';
       }
       
       // 延迟确保DOM更新，使用多重延迟确保组件完全加载
       this.$nextTick(() => {
// 再次延迟确保Element UI组件完全渲染
         setTimeout(() => {
// 强制更新组件
           this.$forceUpdate();
         }, 100);
       });
      
             // 处理付款天数
       if (contract.paymentDays && contract.paymentDays.length > 0) {
         this.paymentDays = contract.paymentDays.map(payment => ({
           days: String(payment.days || ''),
           percentage: String(payment.percentage || '')
         }));
       } else {
         this.paymentDays = [{ days: '30', percentage: '70.00' }];
       }
       
       // 处理变动利率
       if (contract.variableInterestRates && contract.variableInterestRates.length > 0) {
this.variableRates = contract.variableInterestRates.map((rate, index) => {
           // 最后一条或endDays为null的，设置为null表示"以上"
           const isLast = index === contract.variableInterestRates.length - 1;
           const isAbove = rate.endDays === null || rate.endDays === undefined;
           return {
             id: rate.id,
             startDays: String(rate.startDays !== undefined ? rate.startDays : ''),
             endDays: (isLast || isAbove) ? null : String(rate.endDays !== undefined ? rate.endDays : ''),
             rate: String(rate.rate !== undefined ? rate.rate : '')
           };
         });
         // 确保最后一条是"以上"格式
         if (this.variableRates.length > 0) {
           const lastRate = this.variableRates[this.variableRates.length - 1];
           this.$set(lastRate, 'endDays', null);
         }
} else {
         // 只有在没有变动利率数据时才设置默认值
         if (this.variableRates.length === 0) {
           this.variableRates = [{ startDays: '0', endDays: null, rate: '0' }];
         }
       }
      
      // 合同清单
      if (contract.contractItems && contract.contractItems.length > 0) {
        this.originalContractItems = JSON.parse(JSON.stringify(contract.contractItems));
this.contractItems = contract.contractItems.map(item => {
          const mappedItem = {
            id: item.id, // 确保ID存在
            sequenceNumber: item.sequenceNumber || 1,
            productName: item.productName || '',
            specification: item.specification || '',
            materialRequirement: item.materialRequirement || '',
            unit: item.unit || '',
            quantity: item.quantity || 0,
            taxRate: this.normalizeTaxRate(item.taxRate) || 13,
            remark: item.remark || ''
          };
          
          // 根据定价方式设置不同的价格字段
          if (item.pricingMethod === 'FLOATING') {
            // 变动价项目
            mappedItem.pricingMethod = 'FLOATING';
            // 使用后台返回的正确字段名
            mappedItem.taxInclusiveBasePrice = item.taxInclusiveBasePrice || 0;
            mappedItem.taxInclusiveFloatingPrice = item.taxInclusiveFloatingPrice || 0;
            mappedItem.taxInclusiveTotalAmount = item.taxInclusiveTotalAmount || 0;
            mappedItem.taxExclusiveUnitPrice = null;
            mappedItem.taxInclusiveUnitPrice = null;
          } else {
            // 固定价项目
            mappedItem.pricingMethod = 'FIXED';
            // 后台返回的字段名可能是 taxExclusiveUnitPrice，优先使用
            mappedItem.taxExclusiveUnitPrice = item.taxExclusiveUnitPrice || 0;
            mappedItem.taxInclusiveUnitPrice = item.taxInclusiveUnitPrice || 0;
            mappedItem.taxInclusiveTotalAmount = item.taxInclusiveTotalAmount || 0;
            mappedItem.taxInclusiveBasePrice = null;
            mappedItem.taxInclusiveFloatingPrice = null;
          }
          
return mappedItem;
        });
      }
      
      // 如果是查看模式，保持在第一步，让用户可以浏览所有步骤
      if (this.isView) {
        this.activeStep = 0;
      }
    },
    
    // 获取合同详情的API调用
    async fetchContractById(id) {
      try {
        const response = await getContractById(id);
        return response;
      } catch (error) {
        console.error('获取合同详情失败:', error);
        throw error;
      }
    },
    
    // 初始化数据
    async initData() {
      await this.fetchUnits();
      
      // 设置合同单位为当前登录的单位
      const currentUser = getUserInfo();
      const currentUnitId = currentUser?.unit_id || currentUser?.unitId;
      if (currentUnitId) {
        this.step1Form.contractUnitId = currentUnitId;
      }
      
      // 项目数据在需求方单位选择后再获取，这里不预先获取
    },
    
    // 获取单位列表
    async fetchUnits() {
      try {
        const currentUser = getUserInfo();
        const currentUnitId = currentUser?.unit_id || currentUser?.unitId || 1;
        
        // 获取供应商（供方单位）
        const suppliersResponse = await getAllSuppliersByUnitId(currentUnitId);
        if (suppliersResponse.data && suppliersResponse.data.success) {
          // 从供应商关系中获取单位信息
          const supplierUnits = suppliersResponse.data.data || [];
          
          // 添加当前登录的单位到供方单位选项中
          const currentUnit = {
            id: currentUnitId,
            unit_name: currentUser?.unit_name || currentUser?.unitName || '当前单位'
          };
          
          // 检查是否已经存在，避免重复
          const exists = supplierUnits.some(unit => unit.id === currentUnit.id);
          if (!exists) {
            supplierUnits.unshift(currentUnit); // 将当前单位放在最前面
          }
          
          this.supplierOptions = supplierUnits;
        }
        
        // 获取客户（需求方单位）- 包含当前登录的单位
        const customersResponse = await getAllCustomersByUnitId(currentUnitId);
        if (customersResponse.data && customersResponse.data.success) {
          // 从客户关系中获取单位信息
          const customerUnits = customersResponse.data.data || [];
          
          // 添加当前登录的单位到需求方单位选项中
          const currentUnit = {
            id: currentUnitId,
            unit_name: currentUser?.unit_name || currentUser?.unitName || '当前单位'
          };
          
          // 检查是否已经存在，避免重复
          const exists = customerUnits.some(unit => unit.id === currentUnit.id);
          if (!exists) {
            customerUnits.unshift(currentUnit); // 将当前单位放在最前面
          }
          
          this.customerOptions = customerUnits;
        }
      } catch (error) {
        console.error('获取单位数据失败:', error);
        this.$message.error('获取单位数据失败');
      }
    },
    
    // 获取项目列表
    async fetchProjects() {
      try {
        // 如果没有选择需求方单位，则不获取项目
        if (!this.step1Form.customerUnitIds || this.step1Form.customerUnitIds.length === 0) {
          this.projectOptions = [];
          return;
        }
        
        const currentUser = getUserInfo();
        const currentUnitId = currentUser?.unit_id || currentUser?.unitId;
        
        if (!currentUnitId) {
          console.warn('未能获取当前用户单位ID');
          this.$message.error('无法获取当前单位信息，请重新登录');
          return;
        }
        
        // 根据选择的需求方单位查询项目
        const projectPromises = this.step1Form.customerUnitIds.map(async (customerUnitId) => {
          try {
            const response = await getProjectsByUnit(customerUnitId);
            if (response.data && response.data.success) {
              return response.data.data || [];
            }
            return [];
          } catch (error) {
            console.error(`获取单位${customerUnitId}的项目失败:`, error);
            return [];
          }
        });
        
        // 等待所有项目查询完成
        const projectResults = await Promise.all(projectPromises);
        
        // 合并所有项目，去重
        const allProjects = [];
        const projectIdSet = new Set();
        
        projectResults.forEach(projects => {
          projects.forEach(project => {
            if (!projectIdSet.has(project.id)) {
              projectIdSet.add(project.id);
              allProjects.push(project);
            }
          });
        });
        
        this.projectOptions = allProjects;
} catch (error) {
        console.error('获取项目数据失败:', error);
        this.$message.error('获取项目数据失败');
        this.projectOptions = [];
      }
    },

    // 处理需求方单位变更
    handleCustomerUnitChange() {
      // 当需求方单位变更时，清空关联项目选择并重新获取项目列表
      this.step1Form.projectIds = [];
      this.$refs.step1Form.clearValidate('projectIds');
      
      // 重新获取项目列表
      this.fetchProjects();
    },
    
    // 下一步
    nextStep() {
      if (this.activeStep === 0) {
        this.$refs.step1Form.validate(valid => {
          if (valid) {
            // 验证需求方或供方单位中至少有一个是当前用户的所属单位
            const currentUnitId = this.step1Form.contractUnitId;
            const supplierUnitId = this.step1Form.supplierUnitId;
            const customerUnitIds = this.step1Form.customerUnitIds || [];
            
            // 验证：需求方单位和供方单位不能是同一个（不允许自己给自己创建合同）
            if (supplierUnitId && customerUnitIds.includes(supplierUnitId)) {
              this.$message.error('需求方单位和供方单位不能是同一个，不允许自己给自己创建合同');
              return;
            }
            
            // 检查供方单位是否是当前用户单位
            const isSupplierCurrentUnit = supplierUnitId && supplierUnitId === currentUnitId;
            
            // 检查需求方单位中是否包含当前用户单位
            const isCustomerCurrentUnit = customerUnitIds.includes(currentUnitId);
            
            // 如果都不匹配，提示错误并阻止进入下一步
            if (!isSupplierCurrentUnit && !isCustomerCurrentUnit) {
              this.$message.error('需求方或供方必须至少有一个是当前用户的所属单位');
              return;
            }
            
            this.activeStep++;
          }
        });
      } else if (this.activeStep === 1) {
        this.$refs.step3Form.validate(valid => {
          if (valid) {
            this.activeStep++;
          }
        });
      }
    },
    
    // 上一步
    prevStep() {
      if (this.activeStep > 0) {
        this.activeStep--;
      }
    },
    
    // 处理利率类型变更
    handleInterestTypeChange() {
      if (this.step3Form.interestRateType === 'VARIABLE') {
        this.step3Form.fixedInterestRate = 0;
        this.step3Form.interestFreeDays = 0; // 浮动利率设置免息天数为0
      } else {
        this.step3Form.interestFreeDays = 30; // 固定利率设置免息天数为30
      }
},
    
    // 处理支付方式变更
    handlePaymentMethodChange() {
      // 将多选的支付方式数组转换为逗号分隔的字符串
      this.step3Form.settlementMethod = this.selectedPaymentMethods.join(',');
},
    
    // 调试方法：检查选择器状态
    debugPaymentMethodsStatus() {
},
    
    // 添加变动利率
    addVariableRate() {
      // 计算下一个区间的开始天数
      let nextStartDays = 0;
      if (this.variableRates.length > 0) {
        const lastRate = this.variableRates[this.variableRates.length - 1];
        // 如果最后一条是"以上"格式（endDays为空或null），则从startDays+1开始
        if (!lastRate.endDays || lastRate.endDays === '' || lastRate.endDays === 'null') {
          nextStartDays = parseInt(lastRate.startDays) + 1;
          // 将最后一条改为普通格式（设置endDays）
          this.$set(lastRate, 'endDays', String(parseInt(lastRate.startDays) + 30));
        } else {
          nextStartDays = parseInt(lastRate.endDays) + 1;
        }
      }
      
      // 新增的最后一条设置为"以上"格式（endDays为null）
      this.variableRates.push({
        startDays: String(nextStartDays),
        endDays: null, // 最后一条的endDays为null，表示"以上"
        rate: '0'
      });
    },
    
    // 删除变动利率
    removeVariableRate(index) {
      this.variableRates.splice(index, 1);
      if (this.variableRates.length === 0) {
        this.addVariableRate();
      } else {
        // 确保最后一条是"以上"格式（endDays为null）
        const lastRate = this.variableRates[this.variableRates.length - 1];
        if (lastRate && lastRate.endDays && lastRate.endDays !== '' && lastRate.endDays !== 'null') {
          this.$set(lastRate, 'endDays', null);
        }
      }
    },
    
    // 添加付款天数
    addPaymentDay() {
      this.paymentDays.push({
        days: '30',
        percentage: '70.00'
      });
    },
    
    // 删除付款天数
    removePaymentDay(index) {
      this.paymentDays.splice(index, 1);
      if (this.paymentDays.length === 0) {
        this.addPaymentDay();
      }
    },
    
    // Excel文件上传前的验证
    beforeExcelUpload(file) {
      const isExcel = 
        file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
        file.type === 'application/vnd.ms-excel' ||
        file.name.endsWith('.xlsx') ||
        file.name.endsWith('.xls');
        
      if (!isExcel) {
        this.$message.error('只能上传Excel文件!');
        return false;
      }
      
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('文件大小不能超过10MB!');
        return false;
      }
      
      return true;
    },
    
    // 处理Excel文件上传
    handleExcelUpload({ file }) {
      const loading = this.$loading({
        lock: true,
        text: '正在解析Excel文件...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          if (!e.target || !e.target.result) {
            throw new Error('文件读取失败');
          }
          
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          
          const { jsonData, headerRowIndex, columns } = this.findExcelImportData(workbook);
          
          if (jsonData && Array.isArray(jsonData) && jsonData.length > 1) {
            const items = [];
            const taxRateErrors = []; // 收集税率为0的错误
            
            for (let i = headerRowIndex + 1; i < jsonData.length; i++) {
              const row = jsonData[i];
              if (row && Array.isArray(row) && row.length > 0 && row[columns.productName]) {
                let item = {};
                const rowNumber = i + 1;
                const productName = String(row[columns.productName] || '');
                
                if (this.step3Form.pricingMethod === 'FIXED') {
                  // 固定价格式：序号、材料名称、规格型号、材质要求、单位、暂定数量、不含税单价(元)、含税单价(元)、含税合价(元)、税率(%)、备注
                  // 处理税率：统一标准化处理，13或0.13都转换为13，6或0.06都转换为6
                  const taxRateValue = row[columns.taxRate];
                  const taxRate = this.normalizeTaxRate(taxRateValue);
                  
                  // 验证税率不能为空或为0（空值会被normalizeTaxRate转换为0）
                  if (taxRate === 0) {
                    // 判断是空值还是0值
                    const isEmpty = taxRateValue === null || taxRateValue === undefined || taxRateValue === '';
                    const errorMsg = isEmpty 
                      ? `第${rowNumber}行（${productName}）：税率不能为空`
                      : `第${rowNumber}行（${productName}）：税率不能为0`;
                    taxRateErrors.push(errorMsg);
                    continue; // 跳过这条记录
                  }
                  
                  item = {
                    sequenceNumber: parseInt(String(row[columns.sequenceNumber])) || rowNumber - headerRowIndex,
                    productName: productName,
                    specification: String(row[columns.specification] || ''),
                    materialRequirement: String(row[columns.materialRequirement] || ''),
                    unit: String(row[columns.unit] || ''),
                    quantity: parseFloat(String(row[columns.quantity])) || 0,
                    pricingMethod: 'FIXED',
                    taxExclusiveUnitPrice: parseFloat(String(row[columns.taxExclusiveUnitPrice])) || 0,
                    taxInclusiveUnitPrice: parseFloat(String(row[columns.taxInclusiveUnitPrice])) || 0,
                    taxInclusiveBasePrice: null,
                    taxInclusiveFloatingPrice: null,
                    taxInclusiveTotalAmount: parseFloat(String(row[columns.taxInclusiveTotalAmount])) || 0,
                    taxRate: taxRate,
                    remark: String(row[columns.remark] || '')
                  };
                  
                  // 验证计算值是否与表格数据一致（仅用于数据验证，不修改备注）
                  const validationMessages = [];
                  
                  // 验证1：含税单价与不含税单价的关系
                  if (item.taxExclusiveUnitPrice && item.taxInclusiveUnitPrice && item.taxRate) {
                    const taxRateDecimal = item.taxRate / 100;
                    const calculatedTaxInclusivePrice = parseFloat((item.taxExclusiveUnitPrice * (1 + taxRateDecimal)).toFixed(8));
                    const calculatedTaxExclusivePrice = parseFloat((item.taxInclusiveUnitPrice / (1 + taxRateDecimal)).toFixed(8));
                    
                    // 使用更小的误差范围（0.00000001）来验证8位小数的精度
                    if (Math.abs(item.taxInclusiveUnitPrice - calculatedTaxInclusivePrice) > 0.00000001) {
                      validationMessages.push(`含税单价${item.taxInclusiveUnitPrice}与不含税单价${item.taxExclusiveUnitPrice}和税率${item.taxRate}%计算出的值${calculatedTaxInclusivePrice}不一致`);
                    }
                    
                    if (Math.abs(item.taxExclusiveUnitPrice - calculatedTaxExclusivePrice) > 0.00000001) {
                      validationMessages.push(`不含税单价${item.taxExclusiveUnitPrice}与含税单价${item.taxInclusiveUnitPrice}和税率${item.taxRate}%计算出的值${calculatedTaxExclusivePrice}不一致`);
                    }
                  }
                  
                  // 验证2：含税合价与含税单价和数量的关系
                  if (item.taxInclusiveUnitPrice && item.quantity && item.taxInclusiveTotalAmount) {
                    const calculatedTotalAmount = parseFloat((item.taxInclusiveUnitPrice * item.quantity).toFixed(2));
                    if (Math.abs(item.taxInclusiveTotalAmount - calculatedTotalAmount) > 0.01) {
                      validationMessages.push(`含税合价${item.taxInclusiveTotalAmount}与含税单价${item.taxInclusiveUnitPrice}和数量${item.quantity}计算出的值${calculatedTotalAmount}不一致`);
                    }
                  }
                  
                  // 注意：验证信息不再添加到备注中，只在保存时进行验证
                } else {
                  // 变动价格式：序号、材料名称、规格型号、材质要求、单位、暂定数量、含税固定价(元)、含税变动价(元)、含税合价(元)、税率(%)、备注
                  // 处理税率：统一标准化处理，13或0.13都转换为13，6或0.06都转换为6
                  const taxRateValue = row[columns.taxRate];
                  const taxRate = this.normalizeTaxRate(taxRateValue);
                  
                  // 验证税率不能为空或为0（空值会被normalizeTaxRate转换为0）
                  if (taxRate === 0) {
                    // 判断是空值还是0值
                    const isEmpty = taxRateValue === null || taxRateValue === undefined || taxRateValue === '';
                    const errorMsg = isEmpty 
                      ? `第${rowNumber}行（${productName}）：税率不能为空`
                      : `第${rowNumber}行（${productName}）：税率不能为0`;
                    taxRateErrors.push(errorMsg);
                    continue; // 跳过这条记录
                  }
                  
                  item = {
                    sequenceNumber: parseInt(String(row[columns.sequenceNumber])) || rowNumber - headerRowIndex,
                    productName: productName,
                    specification: String(row[columns.specification] || ''),
                    materialRequirement: String(row[columns.materialRequirement] || ''),
                    unit: String(row[columns.unit] || ''),
                    quantity: parseFloat(String(row[columns.quantity])) || 0,
                    pricingMethod: 'FLOATING',
                    taxExclusiveUnitPrice: null,
                    taxInclusiveBasePrice: parseFloat(String(row[columns.taxInclusiveBasePrice])) || 0,
                    taxInclusiveFloatingPrice: parseFloat(String(row[columns.taxInclusiveFloatingPrice])) || 0,
                    taxInclusiveTotalAmount: parseFloat(String(row[columns.taxInclusiveTotalAmount])) || 0,
                    taxRate: taxRate,
                    remark: String(row[columns.remark] || '')
                  };
                  
                  // 验证含税合价与基础价+变动价和数量的关系（仅用于数据验证，不修改备注）
                  const validationMessages = [];
                  
                  if (item.taxInclusiveBasePrice !== undefined && item.taxInclusiveFloatingPrice !== undefined && item.quantity && item.taxInclusiveTotalAmount) {
                    const unitPrice = (item.taxInclusiveBasePrice || 0) + (item.taxInclusiveFloatingPrice || 0);
                    const calculatedTotalAmount = parseFloat((unitPrice * item.quantity).toFixed(2));
                    
                    if (Math.abs(item.taxInclusiveTotalAmount - calculatedTotalAmount) > 0.01) {
                      validationMessages.push(`含税合价${item.taxInclusiveTotalAmount}与含税固定价${item.taxInclusiveBasePrice}、含税变动价${item.taxInclusiveFloatingPrice}和数量${item.quantity}计算出的值${calculatedTotalAmount}不一致`);
                    }
                  }
                  
                  // 注意：验证信息不再添加到备注中，只在保存时进行验证
                }
                
                items.push(item);
              }
            }
            
            // 检查是否有税率为空或为0的错误
            if (taxRateErrors.length > 0) {
              const errorMessage = '导入失败：以下清单项的税率不能为空或为0：\n' + taxRateErrors.join('\n');
              this.$alert(errorMessage, '税率验证失败', {
                confirmButtonText: '确定',
                type: 'error',
                dangerouslyUseHTMLString: false
              });
              loading.close();
              return; // 阻止导入
            }
            
            this.contractItems = items;
            // 导入后重新排列序号
            this.reorderSequenceNumbers();
            this.$message.success(`成功导入 ${items.length} 条记录`);
          } else {
            this.$message.warning('导入的Excel文件没有有效数据');
          }
          
          loading.close();
        } catch (error) {
          console.error('解析Excel文件失败:', error);
          this.$message.error(error.message || '解析Excel文件失败，请检查文件格式');
          loading.close();
        }
      };
      
      reader.onerror = () => {
        this.$message.error('读取文件失败');
        loading.close();
      };
      
      reader.readAsArrayBuffer(file);
    },

    normalizeExcelHeader(value) {
      return String(value == null ? '' : value)
        .replace(/[\s\r\n]/g, '')
        .replace(/（/g, '(')
        .replace(/）/g, ')');
    },

    findExcelImportData(workbook) {
      const headerMatchers = {
        sequenceNumber: header => header === '序号',
        productName: header => header === '材料名称',
        specification: header => header === '规格型号',
        materialRequirement: header => header === '材质要求',
        unit: header => header === '单位',
        quantity: header => header === '暂定数量',
        taxExclusiveUnitPrice: header => header.includes('不含税单价'),
        taxInclusiveUnitPrice: header => header.includes('含税单价') && !header.includes('不含税'),
        taxInclusiveBasePrice: header => header.includes('含税固定价'),
        taxInclusiveFloatingPrice: header => header.includes('含税变动价'),
        taxInclusiveTotalAmount: header => header.includes('含税合价'),
        taxRate: header => header.startsWith('税率'),
        remark: header => header === '备注'
      };
      const commonRequiredColumns = [
        'productName', 'specification', 'unit', 'quantity',
        'taxInclusiveTotalAmount', 'taxRate'
      ];
      const priceRequiredColumns = this.step3Form.pricingMethod === 'FIXED'
        ? ['taxExclusiveUnitPrice', 'taxInclusiveUnitPrice']
        : ['taxInclusiveBasePrice', 'taxInclusiveFloatingPrice'];
      const requiredColumns = commonRequiredColumns.concat(priceRequiredColumns);
      let bestMatch = null;

      workbook.SheetNames.forEach(sheetName => {
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, {
          header: 1,
          defval: null,
          raw: true
        });

        jsonData.slice(0, 30).forEach((row, headerRowIndex) => {
          if (!Array.isArray(row)) return;

          const columns = {};
          row.forEach((cell, columnIndex) => {
            const header = this.normalizeExcelHeader(cell);
            Object.keys(headerMatchers).forEach(key => {
              if (columns[key] === undefined && headerMatchers[key](header)) {
                columns[key] = columnIndex;
              }
            });
          });

          const matchedRequiredCount = requiredColumns.filter(key => columns[key] !== undefined).length;
          if (!bestMatch || matchedRequiredCount > bestMatch.matchedRequiredCount) {
            bestMatch = { jsonData, headerRowIndex, columns, matchedRequiredCount, sheetName };
          }
        });
      });

      if (!bestMatch || bestMatch.matchedRequiredCount !== requiredColumns.length) {
        const missingColumns = requiredColumns
          .filter(key => !bestMatch || bestMatch.columns[key] === undefined)
          .map(key => ({
            productName: '材料名称',
            specification: '规格型号',
            unit: '单位',
            quantity: '暂定数量',
            taxExclusiveUnitPrice: '不含税单价',
            taxInclusiveUnitPrice: '含税单价',
            taxInclusiveBasePrice: '含税固定价',
            taxInclusiveFloatingPrice: '含税变动价',
            taxInclusiveTotalAmount: '含税合价',
            taxRate: '税率'
          }[key]));
        throw new Error(`未找到符合${this.step3Form.pricingMethod === 'FIXED' ? '固定价' : '变动价'}格式的工作表，缺少列：${missingColumns.join('、')}`);
      }

      return bestMatch;
    },
    
    // 删除清单项
    async removeItem(index) {
      const item = this.contractItems[index];
      if (!item) return;
      if (this.contractId && item.id) {
        try {
          const response = await check_contract_item_deletion(this.contractId, item.id);
          if (!response.data || !response.data.success) {
            this.$message.warning(response.data && response.data.message ? response.data.message : '该产品不能删除');
            return;
          }
        } catch (error) {
          const message = error.response && error.response.data && error.response.data.message;
          this.$message.warning(message || '校验产品是否可删除失败，请稍后重试');
          return;
        }
      }
      this.contractItems.splice(index, 1);
      // 删除后重新排列序号
      this.reorderSequenceNumbers();
    },
    
    // 重新排列序号
    reorderSequenceNumbers() {
      this.contractItems.forEach((item, index) => {
        item.sequenceNumber = index + 1;
      });

    },
    
         // 获取计价方式描述
     getPricingMethodDescription() {
       if (this.step3Form.pricingMethod === 'FIXED') {
         return '固定价模式：系统直接读取表格中的不含税单价、含税单价和含税合价数据，保存时会进行数据验证';
       } else {
         return '变动价模式：系统直接读取表格中的含税固定价、含税变动价和含税合价数据，保存时会进行数据验证';
       }
     },
    
         // 获取上传提示文本
     getUploadTipText() {
              if (this.step3Form.pricingMethod === 'FIXED') {
          return '请确保Excel文件包含以下列：序号、材料名称、规格型号、材质要求、单位、暂定数量、不含税单价(元)、含税单价(元)、含税合价(元)、税率(%)、备注。系统将直接读取表格数据，保存时会进行数据验证';
        } else {
          return '请确保Excel文件包含以下列：序号、材料名称、规格型号、材质要求、单位、暂定数量、含税固定价(元)、含税变动价(元)、含税合价(元)、税率(%)、备注。系统将直接读取表格数据，保存时会进行数据验证';
        }
     },
    
    // 下载模板
    downloadTemplate() {
      if (!this.step3Form.pricingMethod) {
        this.$message.warning('请先选择计价方式');
        return;
      }
      
      let templateUrl = '';
      let templateName = '';
      
      if (this.step3Form.pricingMethod === 'FIXED') {
        templateUrl = '/static/template/fixed_list.xlsx';
        templateName = '固定价清单模板.xlsx';
      } else {
        templateUrl = '/static/template/float_list.xlsx';
        templateName = '变动价清单模板.xlsx';
      }
      
      // 创建下载链接
      const link = document.createElement('a');
      link.href = templateUrl;
      link.download = templateName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      this.$message.success(`正在下载${templateName}`);
    },
    
    // 截断文本显示，默认为20个字符
    truncateText(text, length = 20) {
      if (!text) return '-';
      const str = String(text);
      return str.length > length ? `${str.slice(0, length)}...` : str;
    },
    
    // 格式化金额
    formatAmount(amount) {
      if (!amount && amount !== 0) return '0.00';
      const num = parseFloat(amount);
      return num.toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    
    // 格式化单价（保留8位小数，去除末尾无意义的0）
    formatUnitPrice(amount) {
      if (!amount && amount !== 0) return '0';
      const num = parseFloat(amount);
      if (isNaN(num)) return '0';
      // 先格式化为8位小数，然后去除末尾的0
      const formatted = num.toFixed(8);
      // 去除末尾的0和小数点（如果有）
      return formatted.replace(/\.?0+$/, '') || '0';
    },

    // 税率标准化：将13或0.13统一转换为13，6或0.06统一转换为6
    normalizeTaxRate(value) {
      if (value === null || value === undefined || value === '') return 0;
      const num = parseFloat(value);
      if (isNaN(num)) return 0;
      // 如果值小于1，说明是小数形式（如0.13），转换为百分比形式（13）
      if (num < 1 && num > 0) {
        return Math.round(num * 100);
      }
      // 如果值大于等于1，说明已经是百分比形式（如13），直接返回整数
      return Math.round(num);
    },
    
    // 格式化百分比（显示时添加%符号）
    formatPercentage(value) {
      if (value === null || value === undefined) return '0%';
      const normalizedValue = this.normalizeTaxRate(value);
      return `${normalizedValue}%`;
    },
    
    // 验证合同清单数据
    validateContractItems() {
      const errors = [];
      
      if (this.contractItems.length === 0) {
        errors.push('合同清单不能为空，请至少添加一个清单项');
        return errors;
      }
      
      this.contractItems.forEach((item, index) => {
        const rowNumber = index + 1;
        
        // 验证税率不能为0
        const normalizedTaxRate = this.normalizeTaxRate(item.taxRate);
        if (normalizedTaxRate === 0) {
          const productName = item.productName || '';
          errors.push(`第${rowNumber}行${productName ? `（${productName}）` : ''}：税率不能为0`);
        }
        
        if (this.step3Form.pricingMethod === 'FIXED') {
          // 固定价模式：检查不含税单价和含税单价
          if (item.taxExclusiveUnitPrice === 0) {
            errors.push(`第${rowNumber}行：不含税单价不能为0`);
          }
          if (item.taxInclusiveUnitPrice === 0) {
            errors.push(`第${rowNumber}行：含税单价不能为0`);
          }
        } else {
          // 变动价模式：检查基础价和变动价
          if (item.taxInclusiveBasePrice === 0 && item.taxInclusiveFloatingPrice === 0) {
            errors.push(`第${rowNumber}行：含税固定价和含税变动价不能同时为0`);
          }
        }
      });
      
      const seenProducts = new Set();
      this.contractItems.forEach((item, index) => {
        const key = [item.productName, item.specification, item.materialRequirement]
          .map(value => value == null ? '' : String(value).trim()).join('\u0001');
        if (seenProducts.has(key)) {
          errors.push(`第${index + 1}行：该产品已存在（名称、规格型号、材质要求不能完全相同）`);
        }
        seenProducts.add(key);
      });
      return errors;
    },
    
    // 保存合同
    async saveContract() {
      try {
        if (this.attachmentUploading) {
          this.$message.warning('附件正在上传，请等待上传完成后再保存合同');
          return;
        }
        this.saving = true;
        
        // 验证合同清单数据
        const validationErrors = this.validateContractItems();
        if (validationErrors.length > 0) {
          const errorMessage = '合同数据验证失败：\n' + validationErrors.join('\n');
          this.$alert(errorMessage, '验证失败', {
            confirmButtonText: '确定',
            type: 'error',
            dangerouslyUseHTMLString: false
          });
          return;
        }
        
        // 构建合同数据
        const contractData = {
          contractName: this.step1Form.contractName,
          // 合同编号由后端生成，前端不传入
          contractDate: new Date().toISOString(),
          contractAmount: 0, // 先设为0，后面计算
          contractType: 'SALES', // 默认销售合同
          pricingMethod: this.step3Form.pricingMethod,
          interestCalculation: this.step3Form.interestCalculation,
          settlementMethod: this.step3Form.settlementMethod,
          settlementCycle: this.step3Form.settlementCycle, // 结算周期
                     paymentDays: this.paymentDays.map(payment => ({
             days: parseInt(payment.days) || 0,
             percentage: parseFloat(payment.percentage) || 0
           })),
          interestFreeDays: this.step3Form.interestFreeDays,
          interestRateType: this.step3Form.interestRateType,
          fixedInterestRate: this.step3Form.interestRateType === 'FIXED' 
            ? this.step3Form.fixedInterestRate 
            : 0,
          // 新增字段：合同单位、供方单位、需求方单位ID
          contractUnitId: this.step1Form.contractUnitId,
          supplierUnitId: this.step1Form.supplierUnitId,
          demandUnitIds: this.step1Form.customerUnitIds,
          // 项目ID
          projectIds: this.step1Form.projectIds, // 关联项目ID
          // 合同联系人和联系电话
          contactPerson: this.step1Form.contactPerson || '',
          contactPhone: this.step1Form.contactPhone || '',
                     // 变动利率
           variableInterestRates: this.step3Form.interestRateType === 'VARIABLE' 
             ? this.variableRates.map((rate, index) => ({
                 id: rate.id ? parseInt(rate.id) : undefined,
                 startDays: parseInt(rate.startDays) || 0,
                 // 最后一条的endDays为null，表示"以上"
                 endDays: (index === this.variableRates.length - 1 || !rate.endDays || rate.endDays === '' || rate.endDays === 'null') 
                   ? null 
                   : parseInt(rate.endDays) || 0,
                 rate: parseFloat(rate.rate) || 0
               })) 
             : [],
          // 合同参与方
          contractParties: [
            // 合同单位（主要客户）
            {
              unitInfoId: this.step1Form.contractUnitId,
              partyType: 'CUSTOMER',
              isPrimary: true,
              remark: '主要客户'
            },
            // 供方单位
            {
              unitInfoId: this.step1Form.supplierUnitId,
              partyType: 'SUPPLIER',
              isPrimary: false,
              remark: '合作供应商'
            },
            // 需求方单位
            ...this.step1Form.customerUnitIds.map(customerId => ({
              unitInfoId: customerId,
              partyType: 'CUSTOMER',
              isPrimary: false,
              remark: '需求方客户'
            }))
          ],
          // 合同明细项目 - 过滤掉数量为0的项目
          contractItems: this.contractItems
            .filter(item => item.quantity > 0) // 只保留数量大于0的项目
            .map((item, index) => {
              const contractItem = {
                // 编辑模式下，如果有ID则保留，否则为新增
                ...(this.isEdit && item.id ? { id: item.id } : {}),
                sequenceNumber: item.sequenceNumber || index + 1, // 确保序号存在
                productName: item.productName,
                specification: item.specification,
                materialRequirement: item.materialRequirement || '',
                unit: item.unit,
                quantity: item.quantity,
                pricingMethod: this.step3Form.pricingMethod === 'FIXED' ? 'FIXED' : 'FLOATING',
                taxRate: this.normalizeTaxRate(item.taxRate) || 13,
                taxInclusiveTotalAmount: item.taxInclusiveTotalAmount,
                remark: item.remark || ''
              };
              
                          // 根据计价方式设置不同的价格字段
              if (this.step3Form.pricingMethod === 'FIXED') {
                // 固定价：设置不含税单价和含税单价，基础价和变动价为null
                contractItem.taxExclusiveUnitPrice = item.taxExclusiveUnitPrice;
                contractItem.taxInclusiveUnitPrice = item.taxInclusiveUnitPrice;
                contractItem.taxInclusiveBasePrice = null;
                contractItem.taxInclusiveFloatingPrice = null;
              } else {
                // 变动价：设置含税固定价和变动价；不含税单价由后端按模式处理
                contractItem.taxInclusiveBasePrice = item.taxInclusiveBasePrice || 0;
                contractItem.taxInclusiveFloatingPrice = item.taxInclusiveFloatingPrice || 0;
                contractItem.taxExclusiveUnitPrice = null;
                contractItem.taxInclusiveUnitPrice = null;
              }
              
              return contractItem;
            })
        };

        if (this.isEdit && this.reviewerId) {
          contractData.reviewerId = this.reviewerId;
        }
        
        // 如果是编辑模式，添加合同ID
        if (this.isEdit && this.contractId) {
          contractData.id = this.contractId;
        }
        
        // 计算合同总金额
        contractData.contractAmount = contractData.contractItems.reduce((sum, item) => {
          return sum + (item.taxInclusiveTotalAmount || 0);
        }, 0);
        
        // 更新contractAmount字段
        contractData.contractAmount = parseFloat(contractData.contractAmount.toFixed(2));
        
        const needsReview = this.isEdit && (this.originalContractStatus === 'DRAFT' || this.hasProductListChanged(contractData.contractItems));
        if (needsReview && !this.reviewerId) {
          const response = await getContractReviewers(this.contractId);
          const users = response.data?.data || response.data || [];
          this.reviewerOptions = users;
          this.reviewDialogVisible = true;
          this.saving = false;
          return;
        }

// 调用API保存合同
        const response = await saveContract(contractData);
        
        if (response.data && response.data.success) {
          const savedContractId = response.data.data && response.data.data.id;
          if (this.temporaryAttachmentCount > 0) {
            if (!savedContractId) {
              this.$message.warning('合同已保存，但返回结果中缺少合同ID，临时附件尚未关联');
              return;
            }
            try {
              const bindResponse = await bindTemporaryContractAttachments(savedContractId, this.uploadToken);
              if (!bindResponse.data || !bindResponse.data.success) {
                throw new Error(bindResponse.data && bindResponse.data.message
                  ? bindResponse.data.message
                  : '附件关联失败');
              }
              this.temporaryAttachmentCount = 0;
              this.uploadToken = '';
            } catch (bindError) {
              this.contractId = savedContractId;
              this.isEdit = true;
              this.pageTitle = '编辑合同';
              this.$message.warning(`合同已保存，但附件关联失败，请重试保存：${bindError.message || '未知错误'}`);
              return;
            }
          }
          const message = this.isEdit ? '合同更新成功' : '合同创建成功';
          this.$message.success(message);
          // 跳转到合同列表页面
          this.$router.push('/contracts');
        } else {
          const message = this.isEdit ? '合同更新失败' : '合同创建失败';
          this.$message.error(response.data?.message || message);
        }
      } catch (error) {
        console.error('保存合同失败:', error);
        const message = this.isEdit ? '合同更新失败' : '合同创建失败';
        this.$message.error(message + ': ' + (error.response?.data?.message || error.message || '未知错误'));
      } finally {
        this.saving = false;
      }
    },

    hasProductListChanged(items = this.contractItems) {
      const normalize = value => value == null ? '' : String(value).trim();
      const normalizeNumber = value => {
        if (value == null || value === '') return '';
        const number = Number(value);
        return Number.isFinite(number) ? number.toString() : normalize(value);
      };
      const key = item => [item.productName, item.specification, item.materialRequirement, item.unit,
        normalizeNumber(item.quantity), item.pricingMethod, normalizeNumber(item.taxExclusiveUnitPrice),
        normalizeNumber(item.taxInclusiveUnitPrice), normalizeNumber(item.taxInclusiveBasePrice),
        normalizeNumber(item.taxInclusiveFloatingPrice), normalizeNumber(item.taxInclusiveTotalAmount),
        normalizeNumber(item.taxRate), item.remark].map(normalize).join('\u0001');
      if (this.originalContractItems.length !== items.length) return true;
      const oldById = new Map(this.originalContractItems.map(item => [item.id, key(item)]));
      return items.some(item => !item.id || oldById.get(item.id) !== key(item));
    },

    async confirmReviewSave() {
      if (!this.reviewerId) {
        this.$message.warning('请选择复核人');
        return;
      }
      this.reviewDialogVisible = false;
      await this.saveContract();
    },
    
    
     
     // 返回
     goBack() {
       this.$router.go(-1);
     },
     
     // 打开清单项编辑对话框
     openItemDialog(item = null, index = -1) {
       this.editingItemIndex = index;
       
       if (item) {
         // 编辑模式
         this.itemDialogTitle = '编辑清单项';
         this.itemForm = {
           sequenceNumber: item.sequenceNumber || 1,
           productName: item.productName || '',
           specification: item.specification || '',
           materialRequirement: item.materialRequirement || '',
           unit: item.unit || '',
           quantity: item.quantity || 0,
           taxExclusiveUnitPrice: item.taxExclusiveUnitPrice || 0,
           taxInclusiveUnitPrice: item.taxInclusiveUnitPrice || 0,
           taxInclusiveBasePrice: item.taxInclusiveBasePrice || 0,
           taxInclusiveFloatingPrice: item.taxInclusiveFloatingPrice || 0,
           taxInclusiveTotalAmount: item.taxInclusiveTotalAmount || 0,
           taxRate: this.normalizeTaxRate(item.taxRate) || 13,
           remark: item.remark || ''
         };
       } else {
         // 新增模式
         this.itemDialogTitle = '新增清单项';
         // 自动生成序号
         const nextSequence = this.contractItems.length > 0 
           ? Math.max(...this.contractItems.map(item => item.sequenceNumber || 0)) + 1 
           : 1;
         this.itemForm = {
           sequenceNumber: nextSequence,
           productName: '',
           specification: '',
           materialRequirement: '',
           unit: '',
           quantity: 0,
           taxExclusiveUnitPrice: 0,
           taxInclusiveUnitPrice: 0,
           taxInclusiveBasePrice: 0,
           taxInclusiveFloatingPrice: 0,
           taxInclusiveTotalAmount: 0,
           taxRate: 13,
           remark: ''
         };
       }
       
       this.itemDialogVisible = true;
       
       // 延迟执行以确保对话框已经渲染
       this.$nextTick(() => {
         if (this.$refs.itemForm) {
           this.$refs.itemForm.clearValidate();
         }
       });
     },
     
     // 关闭清单项编辑对话框
     closeItemDialog() {
       this.itemDialogVisible = false;
       this.editingItemIndex = -1;
       this.itemForm = {
         sequenceNumber: 1,
         productName: '',
         specification: '',
         materialRequirement: '',
         unit: '',
         quantity: 0,
         taxExclusiveUnitPrice: 0,
         taxInclusiveUnitPrice: 0,
         taxInclusiveBasePrice: 0,
         taxInclusiveFloatingPrice: 0,
         taxInclusiveTotalAmount: 0,
         taxRate: 13,
         remark: ''
       };
       
       if (this.$refs.itemForm) {
         this.$refs.itemForm.clearValidate();
       }
     },
     
     // 保存清单项
     saveItem() {
       this.$refs.itemForm.validate(valid => {
         if (valid) {
           // 验证单价和税率不能为0
           const validationErrors = [];
           
           // 验证税率不能为0
           const normalizedTaxRate = this.normalizeTaxRate(this.itemForm.taxRate);
           if (normalizedTaxRate === 0) {
             validationErrors.push('税率不能为0');
           }
           
           if (this.step3Form.pricingMethod === 'FIXED') {
             if (this.itemForm.taxExclusiveUnitPrice === 0) {
               validationErrors.push('不含税单价不能为0');
             }
             if (this.itemForm.taxInclusiveUnitPrice === 0) {
               validationErrors.push('含税单价不能为0');
             }
           } else {
             if (this.itemForm.taxInclusiveBasePrice === 0 && this.itemForm.taxInclusiveFloatingPrice === 0) {
               validationErrors.push('含税固定价和含税变动价不能同时为0');
             }
           }
           
           if (validationErrors.length > 0) {
             const errorMessage = '清单项验证失败：\n' + validationErrors.join('\n');
             this.$alert(errorMessage, '验证失败', {
               confirmButtonText: '确定',
               type: 'error',
               dangerouslyUseHTMLString: false
             });
             return;
           }
           
           const itemData = {
             id: this.editingItemIndex >= 0 ? this.contractItems[this.editingItemIndex].id : undefined,
             sequenceNumber: this.itemForm.sequenceNumber,
             productName: this.itemForm.productName,
             specification: this.itemForm.specification,
             materialRequirement: this.itemForm.materialRequirement,
             unit: this.itemForm.unit,
             quantity: this.itemForm.quantity,
             taxRate: this.normalizeTaxRate(this.itemForm.taxRate) || 13,
             remark: this.itemForm.remark,
             pricingMethod: this.step3Form.pricingMethod
           };
           
           // 根据计价方式设置价格字段
           if (this.step3Form.pricingMethod === 'FIXED') {
             itemData.taxExclusiveUnitPrice = this.itemForm.taxExclusiveUnitPrice;
             itemData.taxInclusiveUnitPrice = this.itemForm.taxInclusiveUnitPrice;
             itemData.taxInclusiveTotalAmount = this.itemForm.taxInclusiveTotalAmount;
             itemData.taxInclusiveBasePrice = null;
             itemData.taxInclusiveFloatingPrice = null;
           } else {
             itemData.taxInclusiveBasePrice = this.itemForm.taxInclusiveBasePrice;
             itemData.taxInclusiveFloatingPrice = this.itemForm.taxInclusiveFloatingPrice;
             itemData.taxInclusiveTotalAmount = this.itemForm.taxInclusiveTotalAmount;
             itemData.taxExclusiveUnitPrice = null;
             itemData.taxInclusiveUnitPrice = null;
           }
           
           if (this.editingItemIndex >= 0) {
             // 编辑模式：更新现有项
             this.$set(this.contractItems, this.editingItemIndex, itemData);
             this.$message.success('清单项更新成功');
           } else {
             // 新增模式：添加新项
             this.contractItems.push(itemData);
             this.$message.success('清单项添加成功');
           }
           
           // 保存后重新排列序号
           this.reorderSequenceNumbers();
           
           this.closeItemDialog();
         }
       });
     },
     
     // 处理税率变更：自动标准化税率（13或0.13都转换为13）
     handleTaxRateChange() {
       if (this.itemForm.taxRate !== null && this.itemForm.taxRate !== undefined) {
         const normalizedRate = this.normalizeTaxRate(this.itemForm.taxRate);
         this.itemForm.taxRate = normalizedRate;
         // 重新计算含税单价和合价
         if (this.step3Form.pricingMethod === 'FIXED') {
           if (this.itemForm.taxExclusiveUnitPrice) {
             this.calculateFromExclusivePrice();
           } else if (this.itemForm.taxInclusiveUnitPrice) {
             this.calculateFromInclusivePrice();
           }
         }
         this.calculateTotalAmount();
       }
     },
     
     // 根据不含税单价计算含税单价和合价
     calculateFromExclusivePrice() {
       if (this.itemForm.taxExclusiveUnitPrice && this.itemForm.taxRate) {
         const taxRateDecimal = this.itemForm.taxRate / 100;
         this.itemForm.taxInclusiveUnitPrice = parseFloat(
           (this.itemForm.taxExclusiveUnitPrice * (1 + taxRateDecimal)).toFixed(8)
         );
         this.calculateTotalAmount();
       }
     },
     
     // 根据含税单价计算不含税单价和合价
     calculateFromInclusivePrice() {
       if (this.itemForm.taxInclusiveUnitPrice && this.itemForm.taxRate) {
         const taxRateDecimal = this.itemForm.taxRate / 100;
         this.itemForm.taxExclusiveUnitPrice = parseFloat(
           (this.itemForm.taxInclusiveUnitPrice / (1 + taxRateDecimal)).toFixed(8)
         );
         this.calculateTotalAmount();
       }
     },
     
     // 计算含税合价
     calculateTotalAmount() {
       if (this.step3Form.pricingMethod === 'FIXED') {
         // 固定价：含税合价 = 含税单价 * 数量
         if (this.itemForm.taxInclusiveUnitPrice && this.itemForm.quantity) {
           this.itemForm.taxInclusiveTotalAmount = parseFloat(
             (this.itemForm.taxInclusiveUnitPrice * this.itemForm.quantity).toFixed(2)
           );
         }
       } else {
         // 变动价：含税合价 = (含税固定价 + 含税变动价) * 数量
         if (this.itemForm.quantity) {
           const unitPrice = (this.itemForm.taxInclusiveBasePrice || 0) + (this.itemForm.taxInclusiveFloatingPrice || 0);
           this.itemForm.taxInclusiveTotalAmount = parseFloat(
             (unitPrice * this.itemForm.quantity).toFixed(2)
           );
         }
       }
     },
     
     // 查询合同联系人用户（非超级管理员）
     async queryContactUsers(queryString, cb) {
       try {
         // 如果没有输入，返回空列表
         if (!queryString || queryString.trim() === '') {
           cb([])
           return
         }
         
         const params = {
           username: queryString.trim(),
           page: 0,
           size: 50,
           sortBy: 'id',
           sortDir: 'asc'
         }
         
         const response = await query_users_pagination(params)
         
         if (response.data && response.data.success) {
           const users = response.data.data?.content || []
           // 过滤掉 roleId 为 1 的超级管理员，并确保用户名包含查询字符串
           const filteredUsers = users.filter(user => {
             // 排除超级管理员
             if (user.roleId === 1) {
               return false
             }
             // 确保用户名匹配（不区分大小写）
             if (queryString && user.username) {
               return user.username.toLowerCase().includes(queryString.toLowerCase())
             }
             return true
           })
           
           cb(filteredUsers)
         } else {
           cb([])
         }
       } catch (error) {
         console.error('查询合同联系人用户失败:', error)
         cb([])
       }
     },
     
     // 合同联系人选择处理
     handleContactPersonSelect(item) {
       // 确保用户名正确设置（去除前后空格）
       this.step1Form.contactPerson = (item.username || '').trim()
       // 设置电话
       this.step1Form.contactPhone = (item.phone || '').trim()
       
       // 清除该字段的验证错误，确保选择后验证状态正确
       this.$nextTick(() => {
         if (this.$refs.step1Form) {
           this.$refs.step1Form.clearValidate('contactPerson')
           // 如果电话也自动填充了，也清除电话字段的验证错误
           if (item.phone) {
             this.$refs.step1Form.clearValidate('contactPhone')
           }
         }
       })
     }
  }
}
</script>

<style lang="scss" scoped>
.contract-create-container {
  padding: 20px;
  background-color: #f0f2f5;
  min-height: calc(100vh - 120px);
}

.page-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.blue-bar {
  width: 4px;
  height: 20px;
  background-color: #409EFF;
  margin-right: 8px;
}

.page-title {
  font-size: 18px;
  font-weight: bold;
  margin: 0;
  color: #333;
}

.steps-container {
  background-color: #fff;
  padding: 30px 20px;
  border-radius: 4px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.step-content {
  background-color: #fff;
  padding: 30px;
  border-radius: 4px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  min-height: 400px;
}

.step-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}

.import-section {
  text-align: center;
  padding: 40px 0;
}

.pricing-method-tip {
  margin-bottom: 20px;
  text-align: left;
}

.template-download {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.template-tip {
  color: #909399;
  font-size: 14px;
}

.upload-tip {
  margin-top: 20px;
  color: #909399;
  font-size: 14px;
  line-height: 1.6;
}

.items-preview {
  margin-top: 30px;
}

.items-preview h4 {
  margin-bottom: 15px;
  color: #333;
}

.preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  
  h4 {
    margin: 0;
  }
}

.variable-rates-container {
  .rate-item {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    
    .rate-days {
      margin-right: 10px;
    }
    
    .rate-value {
      margin: 0 10px;
    }
    
    .unit-text {
      color: #606266;
      margin: 0 5px;
      white-space: nowrap;
    }
  }
}

.payment-days-container {
  .payment-item {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    
    .payment-days {
      margin-right: 10px;
    }
    
    .payment-percentage {
      margin: 0 10px;
    }
    
    .unit-text {
      color: #606266;
      margin: 0 5px;
      white-space: nowrap;
    }
  }
}

.unit-text {
  color: #606266;
  margin-left: 5px;
  display: inline-block;
  vertical-align: middle;
  line-height: 32px;
}

.step-actions {
  text-align: center;
  padding: 20px 0;
  
  .el-button {
    margin: 0 10px;
    min-width: 100px;
  }
  
  .view-mode-tip {
    margin-bottom: 20px;
    text-align: left;
    
    .el-alert {
      margin: 0;
    }
  }
}

::v-deep .el-form-item__label {
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

::v-deep .el-form-item__content {
  display: block;
}

::v-deep .el-radio-group {
  display: flex;
  align-items: center;
}

::v-deep .el-radio {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

::v-deep .el-radio__label {
  line-height: 1;
  padding-left: 8px;
}

::v-deep .el-radio__input {
  display: flex;
  align-items: center;
}

::v-deep .el-radio__inner {
  margin: 0;
}

::v-deep .el-input-number {
  width: 100%;
}

::v-deep .el-select {
  width: 100%;
}

.empty-items-section {
  text-align: center;
  padding: 40px 0;
  
  .empty-tip {
    margin-top: 15px;
    color: #909399;
    font-size: 14px;
  }
}

.dialog-footer {
  text-align: right;
}

// 用户自动完成选项样式
.user-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  .user-name {
    font-weight: 500;
    color: #303133;
  }
  
  .user-phone {
    font-size: 12px;
    color: #909399;
    margin-left: 10px;
  }
}
</style>

<style lang="scss">
.spec-tooltip {
  max-width: 600px !important;
  white-space: normal;
  word-break: break-all;
}
</style>
